import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer-quality">
      <div className="footer-container">
        <img
          src="https://cms.qualityseal.com.mx/contenido/uploads/logo_0b73df3fcc.png"
          alt="Quality Seal"
          className="footer-logo"
        />
        <p>&copy; {new Date().getFullYear()} Quality Seal. Todos los derechos reservados.</p>
        <span className="footer-subtext">Construido con ❤️</span>
      </div>
    </footer>
  );
};

export default Footer;
